<nav class="navbar bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand custom-text-color" href="#">
      <img src="assets/images/enterprise-logos/logo_tex_vertical.png" alt="Logo Tex" width="30" height="24">
      Tex
    </a>
  </div>
</nav>

<div class="main-content">
  <div class="row">
    <div class="col-xl-12">
      <div class="card custom-card overflow-hidden">
        <div class="card-body p-4">

          <!-- Título: Registro de usuarios -->
          <h3 class="text-center mb-4">Carga de Usuarios CCI</h3>
          <h5 *ngIf="originalForm" class="text-center mb-4">
            Asegurate que la cuenta CCI que ingresaste este a tu nombre. <br>
            Es decir tu seas el titular de esta cuenta. <br>
            De lo contrario no recibirás los abonos.
          </h5>
          <h5 *ngIf="isExceptionalBeneficiary" class="text-center mb-4">
            Asegúrate que el CCI ingresado esté al nombre del destinatario. <br>
            De lo contrario no recibirás los abonos.
          </h5>
          <!--Formulario clasico-->
          <div *ngIf="originalForm">
            <form [formGroup]="formUploadUsers" class="content-form" (ngSubmit)="sendUploadUserInformation()">
            <div class="row">
              <!-- Tipo de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentType" class="form-label fuenteGeneral">Tipo de Documento</label>
                  <select formControlName="documentType" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('documentType').invalid && formUploadUsers.get('documentType').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let documentType of documentTypes" [ngValue]="documentType">
                      {{ documentType.type }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('documentType').invalid && formUploadUsers.get('documentType').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Número de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentNumber" class="form-label fuenteGeneral">Número de Documento</label>
                  <input
                  matInput
                  maxlength="20"
                  formControlName="documentNumber"
                  class="form-control"
                  placeholder="Ingrese su número de documento"
                  (keypress)="validateDocNumberInput($event)"
                  [ngClass]="{
                    'is-invalid': formUploadUsers.get('documentNumber')?.invalid && formUploadUsers.get('documentNumber')?.touched
                  }">

                  <div *ngIf="formUploadUsers.get('documentNumber').invalid && formUploadUsers.get('documentNumber').touched" class="invalid-feedback">
                    <!--<small>Este campo es obligatorio y debe ser válido.</small>-->
                    <small *ngIf="formUploadUsers.get('documentNumber')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('documentNumber')?.errors?.['pattern']">
                      El formato del número de documento es inválido.
                    </small>
                  </div>
                </div>
              </div>

              <!-- Nombre -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="name" class="form-label fuenteGeneral">Nombre</label>
                  <input matInput maxlength="50" formControlName="name" class="form-control"
                    placeholder="Ingrese su nombre"
                    [ngClass]="{'is-invalid': formUploadUsers.get('name').invalid && formUploadUsers.get('name').touched}">
                  <div *ngIf="formUploadUsers.get('name').invalid && formUploadUsers.get('name').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Paterno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="lastname" class="form-label fuenteGeneral">Apellido Paterno</label>
                  <input matInput maxlength="50" formControlName="lastname" class="form-control"
                    placeholder="Ingrese su apellido paterno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('lastname').invalid && formUploadUsers.get('lastname').touched}">
                  <div *ngIf="formUploadUsers.get('lastname').invalid && formUploadUsers.get('lastname').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Materno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="maternalLastname" class="form-label fuenteGeneral">Apellido Materno</label>
                  <input matInput maxlength="50" formControlName="maternalLastname" class="form-control"
                    placeholder="Ingrese su apellido materno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('maternalLastname').invalid && formUploadUsers.get('maternalLastname').touched}">
                  <div *ngIf="formUploadUsers.get('maternalLastname').invalid && formUploadUsers.get('maternalLastname').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Correo Electrónico -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="email" class="form-label fuenteGeneral">Correo Electrónico</label>
                  <input matInput type="email" formControlName="email" class="form-control"
                    placeholder="Ingrese su correo electrónico"
                    [ngClass]="{'is-invalid': formUploadUsers.get('email').invalid && formUploadUsers.get('email').touched}">
                  <div *ngIf="formUploadUsers.get('email').invalid && formUploadUsers.get('email').touched" class="invalid-feedback">
                    <small *ngIf="formUploadUsers.get('email')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('email')?.errors?.['pattern']">
                      El correo debe tener un formato correcto
                    </small>
                  </div>
                </div>
              </div>

               <!-- Tipo de cuenta bancaria -->
               <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="accountType" class="form-label fuenteGeneral">Tipo de Cuenta Bancaria</label>
                  <select formControlName="accountType" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('accountType').invalid && formUploadUsers.get('accountType').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let accountType of bankAccountTypes" [value]="accountType.id">
                      {{ accountType.typeES }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('accountType').invalid && formUploadUsers.get('accountType').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Nombre del Banco -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="bankName" class="form-label fuenteGeneral">Nombre del Banco</label>
                  <select formControlName="bankName" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('bankName').invalid && formUploadUsers.get('bankName').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let bankName of banks" [value]="bankName.id">
                      {{ bankName.name }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('bankName').invalid && formUploadUsers.get('bankName').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Código de Cuenta Interbancario (CCI) -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="cci" class="form-label fuenteGeneral">
                    Código de Cuenta Interbancario (CCI)
                    @for(popover of SvgPopover;track popover){
                      <spk-spkpopovers [class]="popover.color" [popoverClass]="popover.class" [popoverContext]="popover.color"
                          [ngbPopover]="popover.content" [innerHTML]="getSanitizedSVG(popover.svg)"></spk-spkpopovers>
                      }
                  </label>
                  <input matInput maxlength="25" formControlName="cci" class="form-control"
                    placeholder="Ingrese el CCI"
                    [ngClass]="{'is-invalid': formUploadUsers.get('cci').invalid && formUploadUsers.get('cci').touched}">
                  <div *ngIf="formUploadUsers.get('cci').invalid && formUploadUsers.get('cci').touched" class="invalid-feedback">
                    <small *ngIf="formUploadUsers.get('cci')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('cci')?.errors?.['pattern']">
                      El CCI debe tener ser numérico y poseer una longitud exacta de 20
                    </small>
                  </div>
                </div>
              </div>



              <!-- Botón de Enviar -->
              <div class="col-12 text-center mt-2">
                <button type="submit" class="btn btn-primary" [disabled]="formUploadUsers.invalid">Enviar Información</button>
              </div>



            </div>
          </form>
          </div>
          <div  *ngIf="isExceptionalBeneficiary">
          <app-upload-info-exceptional-beneficiary
          [initialData]="dataForExceptionalForm"
          (infoSentSuccessfully)="onInfoSentSuccess()"></app-upload-info-exceptional-beneficiary>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
